import React, { useEffect, useState, useRef } from "react";

import moment from "moment";

import { useUser, useLang } from "../zustand/store.js";

import { toast } from 'react-toastify';

import routes from "../libs/routes";
import images from "../libs/images";
import consts from "../libs/consts";

import { numFormat, errorMessage } from "../utils/utils";
import * as APIS from "../utils/service";

import Image from '../components/Image';
import InputFile from '../components/InputFile';
import Input from '../components/Input';
import Button from '../components/Button';
import ContainerLoader from '../components/ContainerLoader';
import Skeleton from '../components/Skeleton';

import { LangText } from "../zustand/dict.js";

// import { lang } from '../utils/utils';

export const Ismobiles = () => {
    if (/Android|iPhone/i.test(navigator.userAgent)) {
        return true;
    } else {
        return false;
    }
}

export default function Pay() {

    const ref = useRef(null);
    const hpref = useRef();
    const emailref = useRef();
    const pwref = useRef();
    const repwref = useRef();
    const nickref = useRef();

    const { user, reload } = useUser();
    const { country, getLang } = useLang();

    const [item, setitem] = useState(new Array(6).fill({}));

    const [selected, setselected] = useState('');
    const [repw, setrepw] = useState('');
    const [nickname, setnickname] = useState('');
    const [profile, setprofile] = useState('');

    const [error, setError] = useState({});

    const [load, setLoad] = useState(true);

    useEffect(() => {

        creditDataFunc();

    }, []);

    const creditDataFunc = () => {

        APIS.post('/user/creditItem').then(({ data }) => {
            console.log('data', data);

            setselected(data?.[0]?.idx);
            setTimeout(() => {
                setitem(data);
            }, 300)

        }).catch(({ response }) => {


        }).finally(() => {
            setLoad(false);
        });
    }

    const reqCharge = () => {
        APIS.post('/user/creditCharge', {
            idx: selected
        }).then(({ data }) => {
            console.log('data', data);
            // window.open(data);
            if (Ismobiles())
                window.open(data.mobile_url, "new")
            else
                window.open(data.online_url, "new", "width=430, height=555, resizable=no, scrollbars=no, status=no;")
        }).catch(({ response }) => {
            console.log(response.data)
        })
    }

    const payFunc = () => {

        if (!selected) {
            toast.error(<LangText id={'error_credit_select'} />);
            return;
        }

        reqCharge();
        // alert('!!결제창 호출!!');
        // toast.success(<LangText id={'success_payment'} />);
        // reload();
    }

    return (
        <>
            <div className="content">
                <div className="profile_setting_box">
                    <p className={['logo']} />
                    <p className="title"><LangText id={'text_buy_credit'} /></p>

                    <div className="my_credit_box">
                        <p className="title"><LangText id={'text_current_credit'} /></p>
                        <p className='sub_title'>{numFormat(user?.point)} <LangText id={'text_credit'} /></p>
                    </div>
                    <div className="credit_list">
                        <p className="title"><LangText id={'text_item_credit'} /></p>
                        <ul className="credit_ul">
                            {item?.map((x, i) => {
                                return (
                                    x?.idx ? (
                                        <li key={i}>
                                            <input type="radio" id={`item${x?.idx}`} name="selected" className="radio" onClick={() => setselected(x?.idx)} checked={selected === x?.idx} />
                                            <label htmlFor={`item${x?.idx}`} className="credit_label">
                                                <p className="price">{numFormat(x?.price)}<LangText id={'text_unit'} /></p>
                                                <p className="bonus">{x?.bonus ? `+${numFormat(x?.bonus)}%` : ''}</p>
                                                <p className="point">{numFormat(x?.point)} <LangText id={'text_credit'} /></p>
                                            </label>
                                        </li>
                                    ) : (
                                        <li key={i}>
                                            <Skeleton />
                                        </li>
                                    )
                                )
                            })}
                        </ul>
                    </div>
                    <div className="after_credit_box" style={{ borderBottom: 'none' }}>
                        <p className="title"><LangText id={'text_after_credit'} /></p>
                        <p className='pay_title'>{numFormat(user?.point + item?.find(x => x?.idx === selected)?.point)} <LangText id={'text_credit'} /></p>
                    </div>

                    <Button title={<LangText id={'btn_pay_go'} />} onClick={payFunc} />
                </div>
            </div>
        </>
    );
}
